import { createReducer, on } from '@ngrx/store';
import { ListSearch, ModuleV1Read } from '@ca/core/models';
import * as appRootActions from './actions/app-root/app-root.actions';
import * as moduleDetailsPageActions from './actions/module-details-page/module-details-page.actions';
import * as myModulesPageActions from './actions/my-modules-page/my-modules-page.actions';
import * as myModuleActions from './actions/_my-modules/my-modules.actions';
import { HttpErrorResponse } from '@angular/common/http';

export const myModulesFeatureKey = 'myModules';

export interface MyModulesLoadingError {
    loading: HttpErrorResponse | { [key: string]: string } | string;
}
export interface MyModulesTotalCountLoadingError {
    loadingTotalCount: HttpErrorResponse | { [key: string]: string } | string;
}
export interface MyModulesDeleteError {
    delete: HttpErrorResponse | { [key: string]: string } | string;
}
export interface MyModulesUpdateError {
    update: HttpErrorResponse | { [key: string]: string } | string;
}
export interface MyModulesPublishError {
    publish: HttpErrorResponse | { [key: string]: string } | string;
}

export interface MyModulesState {
    isLoading: boolean;
    modules: ModuleV1Read[];
    totalCount: number;
    filteredTotalCount: number;
    query: ListSearch | undefined;
    error?: MyModulesLoadingError | MyModulesTotalCountLoadingError | MyModulesDeleteError | MyModulesPublishError | MyModulesUpdateError | undefined;
    selectedModule?: ModuleV1Read;
}

export const initialState: MyModulesState = {
    query: undefined,
    isLoading: false,
    modules: [],
    totalCount: 0,
    filteredTotalCount: 0,
    error: undefined,
    selectedModule: undefined,
};

export const reducer = createReducer(
    initialState,

    on(appRootActions.loadMyModules, myModuleActions.loadMyModules, myModulesPageActions.loadMyModules, moduleDetailsPageActions.loadMyModules, state => ({
        ...state,
        isLoading: true,
    })),
    on(myModuleActions.loadMyModulesSuccess, myModuleActions.loadMyModulesCacheSuccess, (state, action) => ({
        ...state,
        query: action.query,
        isLoading: false,
        modules: action.modules,
        filteredTotalCount: action.filteredTotalCount,
        error: undefined,
    })),
    on(myModuleActions.loadMyModulesFailure, (state, action) => ({
        ...state,
        query: undefined,
        isLoading: false,
        error: action.error,
    })),
    on(myModuleActions.loadMyModulesTotalCountSuccess, (state, action) => ({
        ...state,
        totalCount: action.totalCount,
    })),
    on(myModuleActions.loadMyModulesTotalCountFailure, (state, action) => ({
        ...state,
        error: action.error,
    })),
    on(myModuleActions.deleteMyModuleSuccess, state => ({
        ...state,
        error: undefined,
    })),
    on(myModuleActions.deleteMyModuleFailure, myModuleActions.publishMyModuleFailure, myModuleActions.updateMyModuleFailure, (state, action) => ({
        ...state,
        error: action.error,
    })),
    on(myModuleActions.deleteMyModuleSuccess, state => ({
        ...state,
        error: undefined,
        selectedModule: undefined,
    })),
    on(myModuleActions.publishMyModuleSuccess, myModuleActions.updateMyModuleSuccess, (state, action) => ({
        ...state,
        error: undefined,
        selectedModule: action.module,
    })),
);
